"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SelectProps_1 = require("./SelectProps");
var styles = require("./Select.css");
var Option_1 = require("./components/Option");
var icons = require("../../../styles/att-icons.css");
var utils_1 = require("../../../utils/utils");
var key_press_1 = require("../../../utils/key-press");
var Label_1 = require("./../Label");
var altIsPressed = key_press_1.KeyPress.altIsPressed;
var tabIsPressed = key_press_1.KeyPress.tabIsPressed;
var enterIsPressed = key_press_1.KeyPress.enterIsPressed;
var upArrowIsPressed = key_press_1.KeyPress.upArrowIsPressed;
var downArrowIsPressed = key_press_1.KeyPress.downArrowIsPressed;
var leftArrowIsPressed = key_press_1.KeyPress.leftArrowIsPressed;
var rightArrowIsPressed = key_press_1.KeyPress.rightArrowIsPressed;
var shiftIsPressed = key_press_1.KeyPress.shiftIsPressed;
var escIsPressed = key_press_1.KeyPress.escIsPressed;
var backspaceIsPressed = key_press_1.KeyPress.backspaceIsPressed;
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select(props) {
        var _this = _super.call(this, props) || this;
        _this.searchStringCode = [];
        _this.searchString = '';
        _this.filteredChoices = [];
        _this.searchResult = [];
        _this.propChoices = []; // contains all props.choices in order to support Template mode
        _this.inputId = _this.guid();
        _this.refDict = {};
        _this.selectRef = {};
        _this.selectParentRef = {};
        _this.onSelect = _this.onSelect.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onDocumentClick = _this.onDocumentClick.bind(_this);
        _this.renderRequiredError = _this.renderRequiredError.bind(_this);
        _this.getSelectText = _this.getSelectText.bind(_this);
        _this.keepPlaceHolder = _this.keepPlaceHolder.bind(_this);
        _this.isRequired = _this.isRequired.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.filteredChoices = _this.props.data.choices;
        _this.propChoices = _this.props.data.choices;
        // this.spi = this.props.data.spi;
        _this.state = {
            currentValue: _this.getCurrentValue(),
            filteredData: _this.props.data.choices,
            isOpen: false,
        };
        return _this;
    }
    Object.defineProperty(Select.prototype, "dropdownIsOpen", {
        get: function () { return this.state.isOpen === true; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "dropdownIsClosed", {
        get: function () { return this.state.isOpen === false; },
        enumerable: false,
        configurable: true
    });
    Select.prototype.getCurrentValue = function () {
        if (this.props.data.templateObject) {
            var templateObject = this.props.data.templateObject;
            var selectedIndex = templateObject.data.findIndex(function (item) { return item.isDefault; });
            if (selectedIndex !== -1 && templateObject.data[selectedIndex].selectedTemplateData) {
                var choiceObj = {
                    displayTemplate: templateObject.selectedTemplate ? React.createElement.apply(React, __spread([templateObject.selectedTemplate], templateObject.data[selectedIndex].selectedTemplateData)) : null,
                    value: templateObject.data[selectedIndex].accessibility ?
                        templateObject.data[selectedIndex].accessibility : selectedIndex.toString(),
                };
                return choiceObj;
            }
        }
        return this.props.data.value || null;
    };
    Select.prototype.componentDidMount = function () {
        this.templateType = this.props.data.templateObject !== undefined;
    };
    Select.prototype.componentDidUpdate = function () {
        if (this.state.isOpen) {
            window.document.addEventListener('click', this.onDocumentClick);
            return;
        }
        this.clearOutsideHandler();
    };
    Select.prototype.componentWillUnmount = function () {
        this.clearOutsideHandler();
    };
    Select.prototype.clearOutsideHandler = function () {
        document.removeEventListener('click', this.onDocumentClick);
    };
    Select.prototype.onDocumentClick = function (e) {
        if (this.state.isOpen) {
            this.onClick(e);
        }
    };
    Select.prototype.onSelect = function (choice, enter) {
        var _this = this;
        var instance = this;
        instance.searchStringCode = [];
        this.setState({ currentValue: choice, invalid: false, isOpen: enter ? this.state.isOpen : false }, function () {
            if (_this.props.events && _this.props.events.onChange) {
                _this.props.events.onChange(_this.state.currentValue);
            }
        });
        if (this.selectRef && this.selectRef.current) {
            this.selectRef.current.focus();
        }
        this.setState({ invalid: false });
        // this.previousChoice = this.state.currentValue;
    };
    Select.prototype.handleKeyDown = function (e) {
        var _this = this;
        var selectedElem = e.currentTarget.querySelector('.Option__menu-item-selected');
        var focusElem = e.currentTarget.querySelector('.Option__menu-item:focus');
        var choiceLength = this.templateType ? this.props.data.templateObject.data.length :
            this.state.filteredData.length;
        if (tabIsPressed(e)) {
            // const lastElem: any = this.refDict[choiceLength - 1];
            // const firstElem: any = this.refDict[0];
            // if (!focusElem && selectedElem) {
            //   selectedElem.focus();
            //   focusElem = selectedElem;
            // } else if (!shiftIsPressed(e) && !focusElem) {
            //   focusElem = firstElem.liRef;
            // } else if (shiftIsPressed(e) && !focusElem && !selectedElem) {
            //   focusElem = firstElem.liRef;
            // }
            // // close options if on last or first option
            // if (this.dropdownIsOpen &&
            //   ((!shiftIsPressed(e) && focusElem === lastElem.liRef) ||
            //     (shiftIsPressed(e) && focusElem === firstElem.liRef))) {
            //   this.setState(() => ({ isOpen: false }));
            // }
            e.stopPropagation();
            var parentElem_1 = e.currentTarget.querySelector('.Select__selection');
            if (this.dropdownIsOpen &&
                ((!shiftIsPressed(e)) ||
                    (shiftIsPressed(e)))) {
                this.setState(function (prevState) { return ({
                    filteredData: _this.props.data.choices,
                    isOpen: !prevState.isOpen,
                }); });
                setTimeout(function () {
                    parentElem_1.focus();
                }, 10);
            }
        }
        else if (backspaceIsPressed(e)) {
            e.stopPropagation();
            e.preventDefault();
            this.searchStringCode.splice(-1);
            this.searchElement(this.searchStringCode);
            // this.setState((prevState) => ({
            //   currentValue: this.previousChoice,
            // }));
        }
        else if (altIsPressed(e) && downArrowIsPressed(e)) {
            e.stopPropagation();
            this.setState(function () { return ({ isOpen: true }); });
        }
        else if (altIsPressed(e) && upArrowIsPressed(e)) {
            e.stopPropagation();
            this.setState(function () { return ({ isOpen: false }); });
        }
        else if (escIsPressed(e)) {
            e.stopPropagation();
            this.setState({ filteredData: this.props.data.choices });
        }
        else if (enterIsPressed(e)) {
            e.stopPropagation();
            this.setState(function (prevState) { return ({
                filteredData: _this.props.data.choices,
                isOpen: !prevState.isOpen,
            }); });
            setTimeout(function () {
                if (_this.dropdownIsOpen && !focusElem && selectedElem) {
                    selectedElem.focus();
                }
            }, 0);
        }
        else if (this.dropdownIsOpen && downArrowIsPressed(e)) {
            e.preventDefault();
            e.stopPropagation();
            var lastElem = this.refDict[choiceLength - 1];
            if (!focusElem && selectedElem) {
                selectedElem.focus();
            }
            else if (e.target === e.currentTarget.querySelector('.' + styles.selection) || e.target === lastElem.liRef) {
                var elem = this.refDict[0];
                elem.liRef.focus();
            }
            else {
                var elem = e.target;
                elem.nextElementSibling.focus();
            }
        }
        else if (this.dropdownIsOpen && upArrowIsPressed(e)) {
            e.preventDefault();
            e.stopPropagation();
            var lastElem = this.refDict[choiceLength - 1];
            var firstElem = this.refDict[0];
            if (!focusElem && selectedElem) {
                selectedElem.focus();
            }
            else if (e.target === e.currentTarget.querySelector('.' + styles.selection) || e.target === firstElem.liRef) {
                lastElem.liRef.focus();
            }
            else {
                var elem = e.target;
                elem.previousElementSibling.focus();
            }
        }
        else if (this.dropdownIsClosed && downArrowIsPressed(e)) {
            e.preventDefault();
            e.stopPropagation();
            if (this.state.currentValue === null ||
                this.state.currentValue.value === this.propChoices[choiceLength - 1].value) {
                this.onSelect(this.propChoices[0], false);
            }
            else if (!this.isExist(this.state.currentValue, this.propChoices)) {
                this.onSelect(this.propChoices[0], false);
            }
            else {
                var i = 0;
                while (i < choiceLength) {
                    if (this.state.currentValue.value === this.propChoices[i].value) {
                        this.onSelect(this.propChoices[i + 1], false);
                        break;
                    }
                    i++;
                }
            }
        }
        else if (this.dropdownIsClosed && upArrowIsPressed(e)) {
            e.preventDefault();
            e.stopPropagation();
            if (this.state.currentValue === null || this.state.currentValue.value === this.propChoices[0].value) {
                this.onSelect(this.propChoices[choiceLength - 1], false);
            }
            else if (!this.isExist(this.state.currentValue, this.propChoices)) {
                this.onSelect(this.propChoices[choiceLength - 1], false);
            }
            else {
                var i = 0;
                while (i < this.propChoices.length) {
                    if (this.state.currentValue.value === this.propChoices[i].value) {
                        this.onSelect(this.propChoices[i - 1], false);
                        break;
                    }
                    i++;
                }
            }
        }
        else if (e.keyCode >= 48 && e.keyCode <= 105) {
            if (this.dropdownIsOpen) {
                this.searchStringCode.push(e.keyCode);
                this.searchElement(this.searchStringCode);
                e.preventDefault();
                e.stopPropagation();
            }
            else {
                this.setState({
                    filteredData: this.props.data.choices,
                    isOpen: true,
                }, function () {
                    if (!focusElem && selectedElem) {
                        selectedElem.focus();
                        _this.searchStringCode.push(e.keyCode);
                        _this.searchElement(_this.searchStringCode);
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });
            }
        }
    };
    Select.prototype.searchElement = function (searchExp) {
        var _this = this;
        this.searchResult = [];
        this.searchString = '';
        var i = 0;
        for (i = 0; i < searchExp.length; i++) {
            this.searchString = this.searchString + String.fromCharCode(searchExp[i]);
        }
        i = 0;
        this.filteredChoices = [];
        while (i < this.propChoices.length) {
            if (String(this.propChoices[i].displayText).toUpperCase().startsWith(this.searchString.toUpperCase()) ||
                String(this.propChoices[i].value).toUpperCase().startsWith(this.searchString.toUpperCase())) {
                this.filteredChoices.push(this.propChoices[i]);
            }
            i++;
        }
        if (this.filteredChoices.length === 0) {
            this.setState({ filteredData: this.props.data.choices });
        }
        else {
            this.setState({ filteredData: this.filteredChoices }, function () {
                _this.updateFocus();
            });
        }
    };
    Select.prototype.updateFocus = function () {
        var i = 0;
        while (i < this.state.filteredData.length) {
            if (this.state.filteredData[i] === this.filteredChoices[0]) {
                var focusElem = this.refDict[i];
                focusElem.liRef.focus();
            }
            i++;
        }
    };
    Select.prototype.startTimer = function (time) {
        var instance = this;
        setTimeout(function () {
            instance.searchStringCode = [];
        }, time);
    };
    Select.prototype.onClick = function (e) {
        var _this = this;
        e.stopPropagation();
        var selectedElem = e.currentTarget.querySelector('.Option__menu-item-selected');
        var focusElem = e.currentTarget.querySelector('.Option__menu-item:focus');
        this.setState(function (prevState) { return ({
            filteredData: _this.props.data.choices,
            isOpen: !prevState.isOpen,
        }); });
        setTimeout(function () {
            if (_this.dropdownIsOpen && !focusElem && selectedElem) {
                selectedElem.focus();
            }
        }, 0);
    };
    Select.prototype.onBlur = function (e) {
        if (e && e.currentTarget) {
            var selectedElem = e.currentTarget.querySelector('.Option__menu-item-selected');
            var firstElem = e.currentTarget.querySelector('.Option__menu-item');
            var focusElem = Array.from(e.currentTarget.querySelectorAll('.Option__menu-item'));
            if (focusElem.indexOf(e.target) !== -1) {
                return;
            }
            if (selectedElem === null) {
                selectedElem = firstElem;
            }
            if (e.relatedTarget && e.relatedTarget === this.selectRef.current || e.relatedTarget === firstElem ||
                e.relatedTarget === selectedElem || e.relatedTarget === this.selectParentRef.current) {
                return;
            }
        }
        if (this.isRequired() && !this.state.currentValue) {
            this.setState({ invalid: true });
        }
        if (this.props.events && this.props.events.onBlur) {
            this.props.events.onBlur(this.state.currentValue);
        }
    };
    Select.prototype.onFocus = function (e) {
        if (this.props.events && this.props.events.onFocus) {
            this.props.events.onFocus(this.state.currentValue);
        }
    };
    Select.prototype.renderRequiredError = function () {
        if (this.isRequired() && this.state.invalid) {
            return (React.createElement("span", { className: styles.requiredError },
                React.createElement("i", { className: [icons.attIcon, icons.attIconBadgealert].join(' ') }),
                " ",
                this.props.options.required));
        }
    };
    Select.prototype.getSelectText = function () {
        if (this.state.currentValue && this.keepPlaceHolder()) {
            if (this.state.currentValue.displayTemplate) {
                return this.state.currentValue.displayTemplate;
            }
            else if (this.state.currentValue.displayText) {
                return this.state.currentValue.displayText;
            }
            return this.state.currentValue.value.toString();
        }
        else if (this.props.options && this.props.options.placeholder) {
            return this.props.options.placeholder;
        }
        else {
            return '-- Choose --';
        }
    };
    Select.prototype.isRequired = function () {
        var options = this.props.options;
        return options && options.required && options.required.length > 0;
    };
    /**
     * This function is to added to handle props changes leading to state change
     * @param newProps
     */
    Select.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.data !== this.props.data && newProps.data.value &&
            newProps.options.flushState) {
            this.setState(function () { return ({
                currentValue: (newProps.data.value || null),
            }); });
        }
    };
    Select.prototype.getOptionID = function () {
        return (this.state.currentValue ? (this.state.currentValue.displayText ?
            this.state.currentValue.displayText : this.state.currentValue.value.toString()) : '');
    };
    Select.prototype.keepPlaceHolder = function () {
        if (this.props.options && this.props.options.keepPlaceholder) {
            return false;
        }
        else {
            return true;
        }
    };
    Select.prototype.generateTemplateOptions = function () {
        this.propChoices = [];
        var OptionTemplate = this.props.data.templateObject.optionTemplate;
        var SelectedTemplate = this.props.data.templateObject.selectedTemplate;
        return this.generateOptionFromTemplateData(OptionTemplate, SelectedTemplate, this.props.data.templateObject.data);
    };
    Select.prototype.generateTemplateOptionsWithGroup = function () {
        var _this = this;
        this.propChoices = [];
        var templateObject = this.props.data.templateObject;
        var OptionTemplate = templateObject.optionTemplate;
        var SelectedTemplate = templateObject.selectedTemplate;
        var GroupTemplate = templateObject.groupObject.groupTemplate;
        var groupedData = templateObject.data.reduce(function (grouped, templateItem) {
            if (templateItem.groupId) {
                if (!grouped[templateItem.groupId]) {
                    grouped[templateItem.groupId] = [];
                }
                grouped[templateItem.groupId].push(templateItem);
            }
            return grouped;
        }, {});
        var startRefIndex = 0;
        var optionsWithGroup = Object.keys(groupedData).map(function (groupKey, index) {
            var options = _this.generateOptionFromTemplateData(OptionTemplate, SelectedTemplate, groupedData[groupKey], startRefIndex);
            startRefIndex = startRefIndex + groupedData[groupKey].length;
            var groupObjectData = templateObject.groupObject.data.find(function (obj) {
                return obj.groupId === groupKey;
            });
            if (!(groupObjectData && groupObjectData.groupTemplateData)) {
                return;
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("li", { tabIndex: -1, key: groupKey }, React.createElement(GroupTemplate, __assign({}, groupObjectData.groupTemplateData))),
                options));
        });
        return optionsWithGroup;
    };
    Select.prototype.generateOptionFromTemplateData = function (OptionTemplate, SelectedTemplate, data, startIndex) {
        var _this = this;
        var startRefIndex = startIndex || 0;
        var options = data.map(function (itemData, i) {
            var choiceObj = {
                displayTemplate: _this.props.data.templateObject.selectedTemplate ? React.createElement.apply(React, __spread([SelectedTemplate], itemData.selectedTemplateData)) : null,
                value: itemData.accessibility ? itemData.accessibility : i.toString(),
            };
            _this.propChoices.push(choiceObj);
            var value = itemData.accessibility ? itemData.accessibility : i.toString();
            var templateProps = __assign(__assign({}, itemData.optionTemplateData), { isSelected: _this.state.currentValue && _this.state.currentValue.value === value });
            return (React.createElement(Option_1.default, { key: i.toString(), data: {
                    choice: choiceObj,
                    isSelected: _this.state.currentValue && _this.state.currentValue.value === i.toString(),
                }, onSelect: _this.onSelect, ref: function (el) { return _this.refDict[startRefIndex + i] = el; }, options: {
                    customDisabledOptionStyles: (_this.props.options && _this.props.options.customDisabledOptionStyles) ?
                        _this.props.options.customDisabledOptionStyles : null,
                } }, React.createElement(OptionTemplate, __assign({}, templateProps))));
        });
        return options;
    };
    Select.prototype.render = function () {
        var _this = this;
        var isOpen = this.state.isOpen;
        var text = this.getSelectText();
        var selectedTitle = typeof (text) === 'string' ? text : this.state.currentValue.value ?
            this.state.currentValue.value.toString() : '';
        var choices = this.state.filteredData;
        var isDecodingNeeded = this.props.data.isDecodingRequired ? this.props.data.isDecodingRequired : false;
        var disabled = this.props.options && this.props.options.disabled ? this.props.options.disabled : false;
        var labelProp = this.props.options && this.props.options.label ? this.props.options.label : false;
        var wrapperCls = this.state.invalid ?
            [styles.container, styles.error, this.props.options.className, this.props.options.errClassName || ''].join(' ') :
            [styles.container, this.props.options.className].join(' ');
        var isRedesign = this.props.options && this.props.options.isRedesign;
        var isRennyStyle = this.props.options && this.props.options.isRennyStyle;
        var containerCls;
        var dropdownCls;
        if (isRennyStyle) {
            containerCls = isOpen ? [styles.selectContainerRenny, styles.selectOpen].join(' ') : styles.selectContainerRenny;
            dropdownCls = isOpen ? [styles.dropdownRenny, styles.selectOpen].join(' ') : styles.dropdownRenny;
        }
        else if (isRedesign) {
            containerCls = isOpen ? [styles.selectContainerRedesign, styles.selectOpen].join(' ') : styles.selectContainerRedesign;
            dropdownCls = isOpen ? [styles.dropdownRedesign, styles.selectOpen].join(' ') : styles.dropdownRedesign;
        }
        else {
            containerCls = isOpen ? [styles.selectContainer, styles.selectOpen].join(' ') : styles.selectContainer;
            dropdownCls = isOpen ? [styles.dropdown, styles.selectOpen].join(' ') : styles.dropdown;
        }
        var selectionCls = isOpen ? [styles.selection, styles.selectOpen].join(' ') : styles.selection;
        var selectedValueCls = styles.selectedValue;
        if (this.props.data.templateObject) {
            this.options = this.props.data.templateObject.groupObject ?
                this.generateTemplateOptionsWithGroup() :
                this.generateTemplateOptions();
        }
        else {
            this.options = choices.map(function (choice, index) { return (React.createElement(Option_1.default, { testId: _this.props.id || utils_1.default(_this.props.testId, 'Option'), key: choice.value, data: { choice: choice, isSelected: _this.state.currentValue && _this.state.currentValue.value === choice.value }, onSelect: _this.onSelect, ref: function (el) { return (choice.disabled ? null : _this.refDict[index] = el); }, options: {
                    customDisabledOptionStyles: (_this.props.options && _this.props.options.customDisabledOptionStyles) ?
                        _this.props.options.customDisabledOptionStyles : null,
                    disabled: choice.disabled,
                    isRedesign: isRedesign,
                    isRennyStyle: isRennyStyle,
                    showCircle: (_this.props.type && _this.props.type === SelectProps_1.SelectType.BUTTON) ? true : false,
                } })); });
        }
        if (disabled) {
            containerCls += " " + styles.disabled;
        }
        if (this.props.type && this.props.type === SelectProps_1.SelectType.BUTTON) {
            containerCls += " " + styles.button;
            dropdownCls += " " + styles.buttonDropdown;
            selectedValueCls += " " + styles.buttonSelectedValue;
        }
        var ulHeight = {};
        if (this.props.options && this.props.options.optionMaxHeight) {
            ulHeight = {
                'max-height': this.props.options.optionMaxHeight,
            };
        }
        return (React.createElement("div", { "data-test-id": this.props.testId, className: wrapperCls, ref: this.selectParentRef, onBlur: this.onBlur, onFocus: this.onFocus, id: this.props.id },
            labelProp && React.createElement("label", { className: styles.selectLabel }, labelProp),
            React.createElement("div", { className: containerCls, onClick: disabled === false ? this.onClick : undefined, onKeyDown: this.handleKeyDown },
                React.createElement("div", { id: this.props.id + this.inputId + (this.props.testId ? '_' + this.props.testId : ''), className: selectionCls, role: "combobox", title: this.props.options && this.props.options.accessibility ?
                        this.props.options.accessibility :
                        'combobox', "aria-autocomplete": "list", "aria-expanded": isOpen, "data-spi": this.props.spi, tabIndex: disabled ? -1 : 0, ref: this.selectRef },
                    React.createElement("div", { className: isRennyStyle ? styles.selectedValueContainerRenny :
                            isRedesign ? styles.selectedValueContainerRedesign : styles.selectedValueContainer },
                        React.createElement("div", { className: selectedValueCls, title: selectedTitle, id: this.props.id + '_' + this.inputId }, this.props.data.templateObject ? text :
                            React.createElement(Label_1.default, { data: { text: selectedTitle, isDecodingRequired: isDecodingNeeded }, options: { className: isRennyStyle ? styles.selectLabelRenny : '' } }))),
                    isRedesign ?
                        React.createElement("i", { className: [styles.arrow, icons.attIcon, icons.attIconArrowDownLight].join(' ') }) :
                        React.createElement("i", { className: [styles.arrow, icons.attIcon, icons.attIconDown].join(' ') })),
                React.createElement("div", { className: dropdownCls },
                    React.createElement("ul", { role: "menu", "aria-activedescendant": this.getOptionID(), style: ulHeight }, this.options))),
            this.renderRequiredError()));
    };
    Select.prototype.isExist = function (valueToFind, choices) {
        var foundValue = null;
        if (valueToFind && choices) {
            foundValue = choices.find(function (item) { return (item.value === valueToFind.value); });
        }
        return foundValue ? true : false;
    };
    Select.prototype.guid = function () {
        return "" + this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
    };
    Select.prototype.S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    Select.defaultProps = {
        options: {
            className: '',
            flushState: false,
            label: '',
        },
        spi: false,
    };
    return Select;
}(React.Component));
exports.default = Select;
//# sourceMappingURL=Select.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Select/Select.js
// module id = 835
// module chunks = 8